import React from 'react';
import Button from 'components/Button';

const TEMPLATE_VERSION_NAME = {
  multiPages: 'Multi-page',
  onePage: 'Single-page',
  ecommerce: 'Online Store',
};

const VersionsToggler = ({ active, versions, onChange }) =>
  versions.map((version, key) => (
    <Button
      key={key}
      className={active.id === version.id ? 'btn active' : ''}
      onClick={() => onChange(version)}
    >
      {TEMPLATE_VERSION_NAME[version.type]}
    </Button>
  ));

export default VersionsToggler;
